import { Timer } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { autoExtendExplainer, type AutoExtendConfig } from "@/lib/auto-extend";

/** "Auto-Extend Enabled" chip shown next to the countdown. */
export function AutoExtendBadge({ config }: { config: AutoExtendConfig }) {
  if (!config.enabled) return null;
  const explain = autoExtendExplainer(config);
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            tabIndex={0}
            aria-label={explain}
            className="inline-flex items-center gap-1.5 rounded-full border border-gold/30 bg-gold/10 px-2.5 py-1 text-[11px] font-medium text-gold"
          >
            <Timer className="h-3 w-3" aria-hidden />
            Auto-Extend Enabled
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-[260px] text-xs">{explain}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
